/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.DocumentSetReviews = {
  _gridApi: null,

  _gridOptions: {
    paginationPageSize: 10,
    headerHeight: 56,
    rowHeight: 44,
    columnDefs: null,
    rowData: null,
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    onGridSizeChanged(event) {
      return event.api.sizeColumnsToFit();
    },
    onVirtualColumnsChanged(event) {
      return DocumentSetReviews.checkAllUsersCheckbox();
    }
  },

  _renderDocumentTitle(data) {
    const documentVersionId = data.data.id;
    const documentVersionTitle = data.data.title;

    return "<label class='custom-checkbox bold'>" +
      `<input type='checkbox' data-document-version-id='${documentVersionId}' class='document-users-all'>` +
      "<span class='checkbox'></span>" +
      `<label class='bold-weight'>${documentVersionTitle}</label>` +
      "</label>";
  },

  _renderDocumentReviewRow(data) {
    const verifierId = data.column.colId;
    const documentVersionId = data.data.id;
    const checked = data.data[verifierId] ? 'checked' : '';

    return "<label class='custom-checkbox'>" +
      `<input type='checkbox' name='document_version_reviews[${documentVersionId}][${verifierId}]' data-document-version-id='${documentVersionId}' data-verifier-id='${verifierId}' id='document_version_reviews[${documentVersionId}][${verifierId}]' value='1' class='assign-reviewers-user assign-verifier-${verifierId} assign-document-version-${documentVersionId}' ${checked}>` +
      "<span class='checkbox'></span>" +
      "</label>";
  },

  _checkAllDocuments(event) {
    const $target = $(event.currentTarget);
    const verifierId = $target.data('verifier-id');
    const checked = $target.is(':checked');
    $(`.assign-verifier-${verifierId}`).prop('checked', checked);

    this._gridApi.forEachNode(function (rowNode) {
      const newData = rowNode.data;
      newData[verifierId] = checked;
      return rowNode.setData(newData);
    });
    return this.checkAllUsersCheckbox();
  },

  _checkAllUsers(event) {
    const $target = $(event.currentTarget);
    const documentVersionId = $target.data('document-version-id');
    const checked = $target.is(':checked');
    $(`.assign-document-version-${documentVersionId}`).prop('checked', checked);

    this._gridApi.forEachNode(function (rowNode) {
      if (rowNode.data.id === documentVersionId) {
        const newData = {};
        _.each(rowNode.data, function (v, k) {
          if ((k === "id") || (k === "title")) {
            return newData[k] = v;
          } else {
            return newData[k] = checked;
          }
        });
        return rowNode.setData(newData);
      }
    });
    return this.checkAllUsersCheckbox();
  },

  _checkUserDocumentsAll() {
    return $('.user-documents-all').each((i, el) => {
      const $el = $(el);
      const verifierId = $el.data('verifier-id');
      const selector = `.assign-verifier-${verifierId}`;
      let checked = true;
      this._gridApi.forEachNode(function (rowNode) { if (!rowNode.data[verifierId]) { return checked = false; } });
      return $el.prop('checked', checked);
    });
  },

  _checkDocumentUsersAll() {
    return $('.document-users-all').each((i, el) => {
      const $el = $(el);
      const documentVersionId = $el.data('document-version-id');
      const selector = `.assign-document-version-${documentVersionId}`;
      let checked = false;
      this._gridApi.forEachNode(function (rowNode) {
        if (rowNode.data.id === documentVersionId) {
          return checked = _.every(rowNode.data, (v, k) => !!v);
        }
      });
      return $el.prop('checked', checked);
    });
  },

  _checkUserCheckbox(event) {
    const $target = $(event.currentTarget);
    const documentVersionId = $target.data('document-version-id');
    const verifierId = $target.data('verifier-id');
    this._gridApi.forEachNode(function (rowNode) {
      if (rowNode.data.id === documentVersionId) {
        const newData = rowNode.data;
        newData[verifierId] = $target.prop('checked');
        return rowNode.setData(newData);
      }
    });
    return this.checkAllUsersCheckbox();
  },

  checkAllUsersCheckbox() {
    this._checkUserDocumentsAll();
    this._checkDocumentUsersAll();
    const checked = _.every(this._gridApi.getModel().rowsToDisplay, rowNode => _.every(rowNode.data, (v, k) => !!v));
    return $('.check-all-documents-users').prop('checked', checked);
  },

  _checkAllDocumentsUsers(event) {
    const checked = $('.check-all-documents-users').prop('checked');
    this._gridApi.forEachNode(function (rowNode) {
      const newData = {};
      _.each(rowNode.data, function (v, k) {
        if ((k === "id") || (k === "title")) {
          return newData[k] = v;
        } else {
          return newData[k] = checked;
        }
      });
      return rowNode.setData(newData);
    });
    return this.checkAllUsersCheckbox();
  },

  _saveAssignedUsers(event) {
    const $target = $(event.currentTarget);
    const disableWith = $target.data('disableWith');
    $target.prop('disabled', true).val(disableWith);
    event.preventDefault();

    const url = $('#save-assigned-reviewers_').val();
    const data = { document_version_reviews: {} };
    this._gridApi.forEachNode(function (rowNode) {
      data['document_version_reviews'][rowNode.data.id] = {};
      return _.each(rowNode.data, function (v, k) {
        if ((k !== 'id') && (k !== 'title')) {
          return data['document_version_reviews'][rowNode.data.id][k] = v;
        }

      });
    });

    data["authenticity_token"] = $('meta[name=csrf-token]').attr('content');
    const method = $('form#assign-reviewers-form input[name="_method"]').val() || 'post';
    return $.ajax({
      url,
      data: JSON.stringify(data),
      contentType: "application/json",
      dataType: 'json',
      method,
      success(response) {
        if (response.redirect_to) {
          return window.location.href = response.redirect_to;
        }
      },
      error(response) {
        return window.location.reload();
      }
    });
  },

  initializeReviewTable(tableSelector, data) {
    const verifiers = _.map(data.verifiers, verifier => JSON.parse(verifier));
    const data_rows = _.map(data.data_rows, dataRow => JSON.parse(dataRow));

    const gridDiv = document.getElementById(tableSelector);
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;

    const HeaderWithCheckboxComponent = function () { };

    HeaderWithCheckboxComponent.prototype.init = function (params) {
      const eTemp = document.createElement('div');
      eTemp.innerHTML = this.getTemplate(params);
      this.eGui = eTemp.firstElementChild;
    };

    HeaderWithCheckboxComponent.prototype.getTemplate = function (params) {
      if (params.verifierId) {
        return "<label class='custom-checkbox inverted-checkbox bold'>" +
          `<input class='user-documents-all' data-verifier-id=${params.verifierId} type='checkbox'>` +
          "<span class='checkbox left'></span>" +
          "<span class='label'>" +
          `<label>${params.displayName}</label>` +
          `<p class='pt-none'>${params.reviewsCount} ` +
          I18n.t('v4.document_set_reviews.assigned_reviews') +
          "</p>" +
          "</span>" +
          "</label>";
      } else {
        return "<label class='custom-checkbox inverted-checkbox bold'>" +
          "<input class='check-all-documents-users' type='checkbox'>" +
          "<span class='checkbox'></span>" +
          `<label>${params.displayName}</label>` +
          "</label>";
      }
    };

    HeaderWithCheckboxComponent.prototype.getGui = function () {
      return this.eGui;
    };

    HeaderWithCheckboxComponent.prototype.destroy = function () { };

    const verifiersColumn = _.map(verifiers, verifier => {
      return {
        headerName: verifier.name,
        field: `${verifier.id}`,
        minWidth: 200,
        headerComponent: HeaderWithCheckboxComponent,
        headerComponentParams: { verifierId: verifier.id, reviewsCount: verifier.reviews_count },
        cellRenderer: rowData => this._renderDocumentReviewRow(rowData)
      };
    });

    const columnDefs = [
      {
        headerName: I18n.t('v4.document_set_reviews.check_all'),
        field: 'title',
        pinned: 'left',
        tooltipField: 'title',
        width: 250,
        suppressSizeToFit: true,
        headerComponent: HeaderWithCheckboxComponent,
        cellRenderer: data => this._renderDocumentTitle(data)
      }].concat(verifiersColumn);
    this._gridApi.setGridOption('columnDefs', columnDefs);
    this._gridApi.setGridOption('rowData', data_rows);
    resizeAgGridTable(`#${tableSelector}`, this._gridOptions, 0, false, false, 20);
    this._gridApi.sizeColumnsToFit();

    $(document).on('change', '.user-documents-all', _.bind(this._checkAllDocuments, this));
    $(document).on('change', '.document-users-all', _.bind(this._checkAllUsers, this));
    $(document).on('change', '.assign-reviewers-user', _.bind(this._checkUserCheckbox, this));
    $(document).on('change', '.check-all-documents-users', _.bind(this._checkAllDocumentsUsers, this));
    $(document).on('click', 'input[type="submit"]', _.bind(this._saveAssignedUsers, this));
    return this.checkAllUsersCheckbox();
  }
};
